import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import SessionCard from '../../../components/ui/SessionCard';
import { getAllUserQuizSessions } from '../../../services/quizSessionService';

const AdminQuizResponsePage = () => {
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSessions = async () => {
      try {
        setLoading(true);
        const {results, next} = await getAllUserQuizSessions();
        console.log(results);
        
        setSessions(results);
      } catch (error) {
        console.error('Error fetching sessions:', error);
        toast.error('Failed to load quiz sessions');
      } finally {
        setLoading(false);
      }
    };

    fetchSessions();
  }, []);

  if (loading) {
    return <div className="text-center py-4">Loading...</div>;
  }

  return (
    <div className="max-w-4xl p-4">
      <h1 className="text-4xl font-medium font-inter text-gray-800 mb-6">Quiz Responses</h1>
      
      <div className="space-y-4">
        {sessions.map((session) => (
          <SessionCard key={session.id} session={session} />
        ))}
      </div>

      {sessions.length === 0 && (
        <div className="text-center py-8">
          <div className="text-5xl mb-4">📝</div>
          <h2 className="text-xl text-gray-600">No quiz responses yet</h2>
        </div>
      )}
    </div>
  );
};

export default AdminQuizResponsePage;